import styled from 'styled-components'
import { Flex } from 'components/common/styles'
import {
  PRIMARY_TEXT,
  PURPLE_RGB,
  LIGHT_PURPLE,
  PURPLE,
} from 'constants/colors'

export const UserListItem = styled.div`
  min-width: 300px;
`

export const ListElement = styled(Flex)`
  margin: 0 10px;
  padding: 8px;
  border-radius: 8px;
  min-width: 210px;
  color: ${PRIMARY_TEXT};
  line-height: 20px;
  cursor: pointer;
  position: relative;
  text-transform: capitalize;
  transition: 0.3s;
  color: ${PRIMARY_TEXT};

  > div {
    margin-right: 8px;
  }

  & div:first-child {
    margin-right: 15px;
  }

  &:hover {
    background-color: rgba(${PURPLE_RGB}, 0.15);
    color: ${PURPLE};

    & div > span > div {
      background: rgba(${PURPLE_RGB}, 0.5);
    }

    .MuiCheckbox-root {
      .MuiIconButton-label {
        > span {
          box-shadow: 0 0 0 3px ${LIGHT_PURPLE};
        }
      }

      .MuiIconButton-label {
        > span {
          border-color: ${PURPLE};
        }
      }
    }
  }

  svg {
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
  }
`
